import type React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import moneyUtils from '../../../../utils/moneyUtils';
import { Button } from '@lb-service/ui';
import appUtils from '../../../../utils/appUtils';

interface Props {
  color: string;
  plan: any;
}

const PricingPlan: React.FC<Props> = (props: Props) => {
  const { plan } = props;
  const router = useRouter();
  const { locale } = router;
  const { t } = useTranslation('common');

  const currencyCodeLists = {
    ja: 'JPY',
    en: 'USD',
    es: 'USD',
    ru: 'USD',
    pt: 'USD',
    tw: 'NTD',
  };
  let currencyCode = moneyUtils.currencyToCode(currencyCodeLists[locale]);
  if (locale === 'pt') currencyCode = 'US$';
  const { prices } = plan;
  const price = prices[currencyCodeLists[locale].toLowerCase()];
  const costPerClass = Math.round((price / plan.tickets) * 10) / 10;
  const btnMessage = t('service.pricing.signup');
  const planBtn = (
    <p className="price-plan-cta">
      <a href={appUtils.getAppPath(locale, 'signup')}>
        <Button size="lg" type="button">
          {btnMessage}
        </Button>
      </a>
    </p>
  );
  return (
    <div
      className="lg:col-span-3 md:col-span-6 col-span-12 price-plan
        price-blog-spotlight price-plan-purple"
    >
      <div className="price-plan-wrap">
        <header className="price-plan-header">
          <h4 className="text-4xl font-bold p-8 text-default">
            {t('service.pricing.planTitle', { title: plan.name })}
          </h4>
        </header>
        <div className="price-body">
          <p className="price-plan-price">
            <sup>{t('service.pricing.currency')}</sup>
            <span className="price">
              {t('service.pricing.price', { price })}
            </span>
            <sub>{t('service.pricing.month')}</sub>
          </p>
          <p className="price-plan-num text-muted">
            {t('service.pricing.numOfClasses', { numOfClasses: plan.tickets })}
          </p>
          <p className="price-per-class text-muted">
            {t('service.pricing.costPerClass', {
              currency: currencyCode,
              costPerClass,
            })}
          </p>
          {planBtn}
        </div>
      </div>
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default PricingPlan;
